module.exports = fox._r("images/clean-thumb-wide.gif", __webpack_public_path__ + "images/clean-thumb-wide.gif");


//////////////////
// WEBPACK FOOTER
// ./images/clean-thumb-wide.gif
// module id = 1033
// module chunks = 4